import AntdGrid from 'antd/lib/grid';
import useBreakpoint from 'antd/lib/grid/hooks/useBreakpoint';
import Col from './Col';
import Row from './Row';
var Grid = AntdGrid;
Grid.useBreakpoint = useBreakpoint;
Grid.Col = Col;
Grid.Row = Row;
export { Row, Col };
export default Grid;